import type {
    WebSkillListParams,
    WebSkillListResponse,
    WebSkillDetailItem,
    WebSkillCreateRequest,
    WebSkillCreateData,
    WebSkillEnableData,
    WebSkillDeleteData,
    WebSkillUpdateRequest,
    WebSkillUpdateData,
    WebSkillImportRequest,
    WebSkillImportData,
    WebMcpListResponse,
    WebMcpDetailItem,
    WebMcpEnableData,
    WebMcpListParams,
    WebMcpDetailParams,
} from '../types';

export const CustomizeService = Symbol('CustomizeService');

export interface CustomizeService {
    getSkillList(params?: WebSkillListParams): Promise<WebSkillListResponse>;
    getSkillDetail(id: string): Promise<WebSkillDetailItem>;
    createSkill(data: WebSkillCreateRequest): Promise<WebSkillCreateData>;
    updateSkill(id: string, data: WebSkillUpdateRequest): Promise<WebSkillUpdateData>;
    enableSkill(id: string): Promise<WebSkillEnableData>;
    disableSkill(id: string): Promise<WebSkillEnableData>;
    deleteSkill(id: string): Promise<WebSkillDeleteData>;
    exportSkill(id: string): Promise<Blob>;
    importSkill(data: WebSkillImportRequest): Promise<WebSkillImportData>;

    getMcpList(params?: WebMcpListParams): Promise<WebMcpListResponse>;
    getMcpDetail(id: string, params?: WebMcpDetailParams): Promise<WebMcpDetailItem>;
    enableMcp(id: string): Promise<WebMcpEnableData>;
    disableMcp(id: string): Promise<WebMcpEnableData>;
}
